export const SPECIAL_MESSAGES = {
  RESET: '/reset',
  CLEAN: '/clean',
};

export const PLATFORM_ORIGIN = 'vs_code_extension';
